export function createImaginalExposureScriptConfig() {
	return {
		title: "Imaginal Exposure Script Worksheet",
		instructions: "Work together on a specific feared outcome. Write in the first person and present tense. During practice, follow the agreed response-prevention rules.",
		allowEmptyFields: true,
		showPriorResults: true,
		fields: [
			{id: "fearedOutcome", purpose: "target", type: "TEXT", title: "Target feared outcome", isRequired: false},
			{id: "preventionRules", purpose: "prevention", type: "MULTILINE", title: "Ritual-prevention rules", isRequired: false},
			{id: "fearedConsequence", purpose: "script", type: "MULTILINE", title: "Feared Consequence", isRequired: false},
			{id: "audioReference", purpose: "audio", type: "TEXT", title: "Recording or audio reference (optional)", isRequired: false},
		],
		scriptConfig: {
			modeId: "readVisualize",
			modes: [
				{id: "readVisualize", title: "Read aloud and visualize", instructions: "Read the script aloud and picture the scene as agreed."},
				{id: "read", title: "Read aloud", instructions: "Read the script aloud as agreed."},
				{id: "visualize", title: "Visualize", instructions: "Picture the scene described in the script as agreed."},
				{id: "record", title: "Record", instructions: "Record the script for repeated use as agreed."},
				{id: "listen", title: "Listen", instructions: "Listen to the recording as agreed."},
				{id: "combined", title: "Combined", instructions: "Use the agreed combination of reading, visualization, recording, or listening."},
			],
			editMode: "practitionerMediated",
			editModeLabels: {practitionerMediated: "Practitioner-mediated editing", collaborative: "Collaborative editing"},
			ruleOptions: [],
			labels: {mode: "Use mode", rules: "Response-prevention rules", readiness: "Readiness", ready: "Ready for practice", draft: "Draft", missing: "Needed before ready", notes: "Practitioner observations", practiceCopy: "Print client practice copy", history: "Earlier scripts", removedRules: "Rules removed from current settings", markReady: "Mark ready", returnDraft: "Return to draft", revise: "Revise script", saveRevision: "Save new review point", cancelRevision: "Cancel revision"},
		},
	}
}

export function createImaginalExposureScriptDemoPayload() {
	return {
		answers: {
			fearedOutcome: "Fear that my family becomes ill after dinner",
			fearedConsequence: "I finish dinner and notice my daughter looks tired. I imagine she has become seriously ill because I overlooked something in the food. I feel the urge to ask everyone how they feel and check the ingredients again. I leave the uncertainty there and continue with the evening.",
			preventionRules: "I will not check the ingredients again, ask for reassurance, or mentally review each step of preparing dinner.",
		},
		readySignature: "",
	}
}
